import Vue from 'vue';



const events = new Vue();



export default events;
